import { render } from "./Pagination.vue?vue&type=template&id=29ea8c6a&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=29ea8c6a&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ea8c6a"]])

export default __exports__